import { api } from "../../services/NetworkBase";

// List types stored in the DropdownListItems table (must match DropdownListTypes in the API).
export const DROPDOWN_LIST_TYPES = {
  TEMPERATURE_COMMENT: "TemperatureComment",
  TEMPERATURE_ACTION_TAKEN: "TemperatureActionTaken",
  PRODUCT_CATEGORY: "ProductCategory",
  PRODUCT_LOCATION: "ProductLocation",
};

// Lists shown in Maintenance > Dropdown Lists. maxLength matches the column the value is saved into.
// To add a new list: add it here and in DropdownListTypes (API), then seed its rows.
export const DROPDOWN_LISTS = [
  { type: DROPDOWN_LIST_TYPES.TEMPERATURE_COMMENT, label: "Temperature Record Comments", itemLabel: "Comment", maxLength: 500 },
  { type: DROPDOWN_LIST_TYPES.TEMPERATURE_ACTION_TAKEN, label: "Temperature Record Actions Taken", itemLabel: "Action Taken", maxLength: 500 },
  { type: DROPDOWN_LIST_TYPES.PRODUCT_CATEGORY, label: "Product Categories", itemLabel: "Category", maxLength: 100 },
  // ENB-584: product locations are now managed under Inventory > Locations (Warehouse > Rack > Shelf).
];

export async function GetDropdownListItems(listType, includeInactive = false) {
  try {
    let response = await api
      .get(`dropdown-lists/${listType}?includeInactive=${includeInactive}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveDropdownListItem(item) {
  try {
    let response = await api.post("dropdown-lists", { json: item }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateDropdownListItem(item) {
  try {
    let response = await api.put("dropdown-lists", { json: item }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

// itemIds: every non-system item of the list, in the new display order.
export async function ReorderDropdownListItems(listType, itemIds) {
  try {
    let response = await api
      .put(`dropdown-lists/${listType}/reorder`, { json: { itemIds } })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteDropdownListItem(id) {
  try {
    let response = await api.delete(`dropdown-lists/${id}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

// Pulls the API's message out of a failed request so the user sees why (duplicate, not admin, etc.).
export async function getDropdownListErrorMessage(error, fallback) {
  try {
    const body = await error?.response?.json();
    return body?.message || fallback;
  } catch {
    return fallback;
  }
}
